import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

export default grapesjs.plugins.add('webconnect-iframe-traits', (editor, opts) => {
  const default_traits = {
    link: {
      type: 'webconnect-iframe',
      label: false,
    },
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };
  loadTraits(editor, options);
});
